<template>
  <v-dialog
    v-model="dialog"
    width="500"
    >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="success"
        depressed
        v-bind="attrs"
        v-on="on"
        >
        Crear nuevo
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        Crear complejo
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="dialog = false"
          >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-form>
          <vuetify-google-autocomplete
            filled
            id="map"
            :label="$t('property.create.type.fields.address')"
            v-model="attributes.fullAddress"
            persistent-hint
            no-filter
            ></vuetify-google-autocomplete>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          depressed
          color="success"
          @click="save"
          >
          Crear
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { CreateBuilding } from '@/graphql/mutations/buildings'

export default {
  data: () => ({
    dialog: false,
    attributes: {
      fullAddress: null
    }
  }),

  methods: {
    save () {
      this.$apollo.mutate({
        mutation: CreateBuilding,
        variables: {
          input: {
            attributes: this.attributes
          }
        }
      }).then ( res => {
        this.$emit('reload')
        this.dialog = false
      })
    }
  }
}
</script>
